import styled from "styled-components";
import img2 from "../../assets/images/bg-3.png";

export const LoginWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  height: 100vh;
  .recup {
    margin-top: 20px;
  }
  .bgImage {
    width: 100%;
    height: 100%;
    border-radius: 12px;
    background-size: cover;
    background-repeat: no-repeat;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .bgColor {
    border: 1px solid #e2e2e2;
    background-color: #ffffff;
    border-radius: 12px;
    padding: 34px 64px;
    width: 80%;
    min-height: 228px;
    position: relative;
  }
  .icon {
    position: absolute;
    top: 24px;
    left: 50px;
    width: 76px;
    height: 64px;
  }
  .title {
    font-size: 28px;
    font-style: italic;
    color: #202224;
    font-weight: 400;
    line-height: 39.2px;
    text-align: center;
  }
  .name {
    font-size: 20px;
    font-weight: 400;
    line-height: 20px;
    text-align: center;
    color: #273b46;
    padding-top: 30px;
  }
  @media (max-width: 1110px) {
    .bgImage {
      display: none;
    }
  }
`;

export const Form = styled.form`
  width: 100%;
  display: flex;
  height: 100%;
  background-image: url(${img2});
  background-size: cover;
  background-repeat: no-repeat;
  justify-content: center;
  position: relative;
  .containr {
    max-width: 550px;
    padding-top: 108px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .header {
    text-align: center;
  }
  .imgGerb {
    width: 96px;
  }
  .titles {
    margin-top: 32px;
    display: flex;
    justify-content: center;
    text-transform: uppercase;
    color: #1b2559;
    font-size: 24px;
    font-weight: 800;
    line-height: 31.2px;
    letter-spacing: -0.02em;
    text-align: center;
    padding: 0px 40px;
  }
  .form {
    background-color: white;
    padding: 36px;
    border-radius: 10px;
    border: 1px solid #e2e2e2;
  }
  .input-wrap {
    margin-top: 20px;
  }
  .form .ant-btn-primary {
    width: 100%;
    height: 48px;
    margin-top: 50px;
  }
  .input-from {
    position: relative;
    display: flex;
    align-items: center;
    .ant-input-affix-wrapper {
      height: 44px;
      border-radius: 8px;
    }
  }
  .input-icon {
    /* position: absolute; */
    /* left: 20px; */
    /* z-index: 1000;/ */
    /* top: 19px; */
    color: #a3aed0;
  }
  .input-from .ant-input-outlined,
  .phone-input {
    border-radius: 8px;
    height: 48px;
    padding-left: 50px;
    font-size: 16px;
    margin-top: 4px;
    background-color: transparent;
    &::placeholder {
      color: #a3aed0;
    }
  }

  .footer {
    position: absolute;
    left: 0px;
    bottom: 0px;
    display: flex;
    width: 100%;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    padding-bottom: 37px;
  }
  .footer-title {
    font-size: 16px;
    font-weight: 500;
    line-height: 16px;
    color: #a3aed0;
    display: flex;
    align-items: center;
  }
  .logo {
    padding-left: 10px;
    font-size: 16px;
    font-weight: 500;
    line-height: 16px;
    text-decoration: none;
    color: #6571ff;
  }
  @media (max-width: 1537px) {
    .containr {
      padding-top: 105px;
    }
    .imgGerb {
      width: 77px;
    }
    .titles {
      margin-top: 20px;
      font-size: 20px;
      line-height: 26.2px;
      letter-spacing: -0.02em;
      padding: 0px 100px;
    }
    .form {
      margin-top: 20px;
      padding: 30px;
    }
  }
  @media (max-width: 590px) {
    .containr {
      width: 90%;
    }
  }
  @media (max-width: 462px) {
    .titles {
      margin-top: 20px;
      font-size: 18px;
      line-height: 24.2px;
      letter-spacing: -0.02em;
      padding: 0px 0px;
    }
  }
`;
